import {
  createContext, useState, useEffect, useRef, useCallback,
} from 'react';

import throttle from 'lodash-es/throttle';

export const Context = createContext({});

export const breakpoints = {
  xl: 1440,
  lg: 1024,
  md: 768,
  sm: 576,
  xs: 0,
};
function getBreakpointByWidth(width) {
  return (
    Object.keys(breakpoints).find(
      (breakpointKey) => width >= breakpoints[breakpointKey],
    ) || 'xs'
  );
}
export default function GridProvider({ children }) {
  const [breakpoint, setBreakpoint] = useState('xl');
  const breakpointRef = useRef('xl');
  const headerMeasurements = useRef({});
  const headerRef = useRef(null);

  useEffect(() => {
    const handleWindowResize = throttle(() => {
      const newBreakpoint = getBreakpointByWidth(window.innerWidth);
      if (breakpointRef.current !== newBreakpoint) {
        setBreakpoint(newBreakpoint);
        breakpointRef.current = newBreakpoint;
      }
      if (headerRef.current) {
        headerMeasurements.current.height = headerRef.current.offsetHeight;
      }
    }, 100);
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  const setHeaderState = useCallback((newState = {}) => {
    headerMeasurements.current = {
      ...headerMeasurements.current,
      ...newState,
    };
    if (headerRef.current) {
      headerMeasurements.current.height = headerRef.current.offsetHeight;
    }
  }, []);
  const getHeaderHeight = useCallback(
    (assumeScrollTo = 0) => {
      const {
        height, possibleOffset, isVisible, isHidingEnabled,
      } = headerMeasurements.current;
      const fullHeight = height || 0;
      const visibleAfterHidingHeight = fullHeight - possibleOffset;
      if (assumeScrollTo > 0 || !isHidingEnabled) {
        return fullHeight;
      }
      if (assumeScrollTo < 0) {
        return visibleAfterHidingHeight;
      }
      return isVisible ? fullHeight : visibleAfterHidingHeight;
    },
    [],
  );

  return (
    <Context.Provider
      value={{
        breakpoint,
        headerRef,
        getHeaderHeight,
        setHeaderState,
      }}
    >
      {children}
    </Context.Provider>
  );
}
